module.exports = "\n<button @click=\"onClose\" :class=\"class\" class=\"btn btn_white newsletter__btn\">\n  <slot></slot>\n</button>\n";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CloseButton.vue
// module id = 104
// module chunks = 0